module.exports = __webpack_public_path__ + "assets/img/86e6f7beda3a57132e13cf0b3bc8c5ca.svg";